import React from "react";

import { toHumanDuration } from "../../utils";
import { formatDateMonthTimeShort } from "~/src/utils/formatting";
import { AlarmIcon, AlarmWrap, Duration, RefreshIcon } from "./styles";

interface AlarmProps {
  value: number | null;
  warn: number;
  alarm: number;
  refresh?: false | (() => void);
  loading?: boolean;
}

const Alarm: React.FC<AlarmProps> = ({
  value,
  warn,
  alarm,
  refresh,
  loading,
}) => {
  let title = "";
  let color = "";

  if (value === null) {
    title = `No action found`;
    color = "lightgray";
  } else if (value >= alarm) {
    color = "red";
    title = `Last recorded action at ${formatDateMonthTimeShort(value)}, over ${toHumanDuration(alarm)} ago`;
  } else if (value >= warn) {
    color = "orange";
    title = `Last recorded action at ${formatDateMonthTimeShort(value)}, over ${toHumanDuration(warn)} ago`;
  } else {
    color = "green";
    title = `Last recorded action at ${formatDateMonthTimeShort(value)}`;
  }

  return (
    <AlarmWrap title={title}>
      <Duration>{toHumanDuration(value)}</Duration>

      {refresh && !loading ? (
        <RefreshIcon style={{ color }} onClick={refresh}>
          &#10227;
        </RefreshIcon>
      ) : (
        <AlarmIcon style={{ color }}>&#9679;</AlarmIcon>
      )}
    </AlarmWrap>
  );
};

export default Alarm;
